import React from 'react';

import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import EditCartItemRoute from 'bento-ordering/cart/containers/EditCartItemRoute';
import { isMobileMedia } from 'bento-ordering/utils/media';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

/**
 * This EditCartItemRouteContainer will render the MenuItemDetail component
 * user wants to edit a cart item when they are on the menus page. The MenuContainer
 * will render as the background, with the MenuItemDetail as foreground.
 */
class EditCartItemRouteContainer extends React.Component {
  render() {
    if (isMobileMedia()) {
      return <EditCartItemRoute />;
    }

    return <MenuContainer shouldOpenEditCartItemModal />;
  }
}

export default withGoogleLibraryLoaded(EditCartItemRouteContainer);
